<template>
  <b-modal
    :id="id"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-title>{{ title }}</template>
    <div class="d-block text-center">
      <div class="form-group">
        <textarea
          class="form-control"
          rows="3"
          :placeholder="content"
          v-model="inputData"
          @keyup="$emit('update:inputData', inputData)"
        ></textarea>
      </div>
    </div>
    <b-button class="mt-3 btn-primary" block @click="confirm()"
      >ยืนยัน</b-button
    >
  </b-modal>
</template>

<script>
export default {
  props: {
    id: String,
    title: String,
    content: String,
    onConfirm: Function,
  },
  data() {
    return {
      inputData: "",
    };
  },
  methods: {
    confirm() {
      if (this.onConfirm && this.inputData) {
        this.onConfirm(this.inputData);
        this.$bvModal.hide(this.id);
      }
    },
  },
};
</script>

